import { Button } from "@svea/design-system-components-react";
import {
	FormWithTracking,
	Grid,
	isRequired,
	TextField,
	trim,
	useText,
	validateSsn,
} from "@sveabank/cc-common";

type Props = {
	onSubmit: (values: { ssn: string }) => void;
};

const GetDisplayNameForm = ({ onSubmit }: Props) => {
	const [t, texts] = useText();
	return (
		<FormWithTracking<{ ssn: string }>
			className="w-full"
			onSubmit={onSubmit}
			initialValues={{ ssn: "" }}
			matomoInstance={window.Matomo}
			render={({ handleSubmit }) => (
				<form onSubmit={handleSubmit} name="displayNameForm">
					<Grid>
						<Grid.Col span={{ base: 12, tablet: 9 }}>
							<TextField
								id="ssn"
								name="ssn"
								fullWidth
								type="text"
								parse={trim}
								label={t(texts.loginPage.loginForm.ssn)}
								validators={[isRequired, validateSsn]}
								helperText={t(texts.applicationSettings.cardSettings.ssnFormat)}
							/>
						</Grid.Col>
						<Grid.Col span={{ base: 12, tablet: 3 }}>
							<Button type="submit" width="full" variant="secondary">
								{t(texts.applicationSettings.buttonText.getDisplayName)}
							</Button>
						</Grid.Col>
					</Grid>
				</form>
			)}
		/>
	);
};

export default GetDisplayNameForm;
